import {Entity} from '../base/entity';

export class Country extends Entity {

  public static readonly TABLENAME = 'country';

  public static readonly ID = 'id';
  public static readonly NAME = 'name';
  public static readonly ISO2 = 'iso2';
  public static readonly ISO3 = 'iso3';
  public static readonly NUMERIC_CODE = 'numeric_code';
  public static readonly CREATED_AT = 'created_at';
  public static readonly UPDATED_AT = 'updated_at';
  public static readonly DELETED_AT = 'deleted_at';

  id:          number;
  name:        string;
  iso2:        string;
  iso3:        string;
  numericCode: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
}
